function setMenuState(menu, isOpen, triggerButtons) {
  menu.classList.toggle("is-active", isOpen);
  menu.setAttribute("aria-hidden", isOpen ? "false" : "true");
  document.body.classList.toggle("site-menu-open", isOpen);

  triggerButtons.forEach((button) => {
    button.setAttribute("aria-expanded", isOpen ? "true" : "false");
  });
}

export function syncSiteHeaderOffset(root = document) {
  const header = root.querySelector("[data-site-header]");

  if (!header || header.dataset.headerOffsetBound === "1") {
    return;
  }

  const apply = () => {
    document.documentElement.style.setProperty(
      "--site-header-height",
      `${Math.ceil(header.getBoundingClientRect().height)}px`
    );
  };

  apply();

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(apply);
    observer.observe(header);
  }

  window.addEventListener("resize", apply);
  window.addEventListener("load", apply);
  document.fonts?.ready?.then(apply);

  header.dataset.headerOffsetBound = "1";
}

export default function initHeaderMenu(root = document) {
  syncSiteHeaderOffset(root);

  const menu = root.querySelector("[data-site-menu]");
  const triggerButtons = root.querySelectorAll("[data-site-menu-toggle]");
  const closeButtons = root.querySelectorAll("[data-site-menu-close]");

  if (!menu || !triggerButtons.length || menu.dataset.menuBound === "1") {
    return;
  }

  const closeMenu = () => setMenuState(menu, false, triggerButtons);

  triggerButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const shouldOpen = menu.getAttribute("aria-hidden") !== "false";
      setMenuState(menu, shouldOpen, triggerButtons);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeMenu);
  });

  menu.querySelectorAll(".site-menu__section-links a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && menu.getAttribute("aria-hidden") === "false") {
      closeMenu();
    }
  });

  menu.dataset.menuBound = "1";
  setMenuState(menu, false, triggerButtons);
}
